// Pre login
export enum EPreAuthRoutes {
  HOME = '/',
  REGISTRATION = '/registration',
  LOGIN_ERROR = '/login-error',
}
